import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';

@Component({
  selector: 'app-field-configurator-canvas',
  imports: [CommonModule, NgxExtendedPdfViewerModule],
  templateUrl: './field-configurator-canvas.component.html',
  styleUrl: './field-configurator-canvas.component.scss',
})
export class FieldConfiguratorCanvasComponent {
  @Input() viewerPdfSource: string | Uint8Array | Blob | null = null;
  @Input() hasPendingSource = false;
  @Input() emptyNoFileMessage = 'No file selected. Go back to Step 1 and add a PDF.';
  @Input() emptyPreparingMessage = 'Preparing PDF preview...';
  @Input() pdfLoadError = '';
  @Input() pdfLoadErrorDetail = '';
  @Input() pdfBootstrapError = '';
  @Input() showViewerInstance = true;
  @Input() viewerRenderNonce = 0;
  @Input() viewerPageBinding: number | undefined = 1;
  @Input() viewerRotation: 0 | 90 | 180 | 270 = 0;
  @Input() pdfLoading = false;
  @Input() canPlaceFields = false;
  @Input() fieldCount = 0;
  @Input() retryButtonLabel = 'Retry preview';
  @Input() showStepOneButton = true;
  @Input() stepOneButtonLabel = 'Go to Step 1';
  @Output() goToStepOne = new EventEmitter<void>();
  @Output() retryPreview = new EventEmitter<void>();
  @Output() pdfLoadingStarts = new EventEmitter<void>();
  @Output() pdfLoaded = new EventEmitter<void>();
  @Output() pdfLoadingFailed = new EventEmitter<unknown>();
  @Output() pagesLoaded = new EventEmitter<unknown>();
  @Output() pageRendered = new EventEmitter<unknown>();
  @Output() pageChange = new EventEmitter<unknown>();
  @Output() rotationChange = new EventEmitter<0 | 90 | 180 | 270>();
}
